var VerifyComponent = /** @class */ (function () {
    function VerifyComponent() {
    }
    VerifyComponent.prototype.ngOnInit = function () {
    };
    return VerifyComponent;
}());
export { VerifyComponent };



// WEBPACK FOOTER //
// ./src/app/verify/verify.component.ts.pre-build-optimizer.js